export default "__VITE_ASSET__45c277eb__"